import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationLicensePost = {
    path: "/license",
    method: ERouteHttpVerb.POST
};
export { routeLocationLicensePost };
